/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02Jg58%7Bwidth%3A8px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VJg58%7Bheight%3A8px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrukLmD%7Bbackground-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02Z49V%7Bwidth%3A2rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VQAma%7Bheight%3A1rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaTCo3%7Btransform%3AtranslateY(-1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcagSbW%7Btransform%3Ascale(.9375)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0yKXXaDIqT%7Btransform-origin%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GTcwRLl21%7Bmargin-inline-start%3Avar(--ds-space-negative-025%2C-2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6B7dHp%7Bz-index%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4Q7zJH%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U1Y8M%7Bpadding-block%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL4gVvo%7Bpadding-inline%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02W9qI%7Bwidth%3A-moz-max-content%3Bwidth%3Amax-content%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrugozt%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3zvHkHwPeg%7Boverflow-wrap%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1T2N03wPeg%7Bword-wrap%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3932vv0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5v1qpb%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VbKFA%7Bheight%3A1.25rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr07p2s%7Balign-self%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { bind } from 'bind-event-listener';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import type { EmojiProvider } from '@atlaskit/emoji';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { useFlags } from '@atlaskit/flag/use-flags';
import ViewAllIcon from '@atlaskit/icon/core/align-text-left';
import PinIcon from '@atlaskit/icon/core/pin';
import PinFilledIcon from '@atlaskit/icon/core/pin-filled';
import InformationIcon from '@atlaskit/icon/core/status-information';
import ButtonItem from '@atlaskit/menu/button-item';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Popup } from '@atlaskit/popup/popup';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import type { AgentCreatorType } from '@atlaskit/rovo-agent-components/common/types';
import { isForgeAgentByCreatorType } from '@atlaskit/rovo-agent-components/common/utils/is-forge-agent';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { MenuList as AtlasMenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuSection as AtlasMenuSection, MenuSectionHeading as AtlasMenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import TooltipPrimitive from '@atlaskit/tooltip/TooltipPrimitive';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';
import { useStagingAreaActions } from '@atlassian/conversation-assistant-store/controllers/staging-area';
import { useScopePopupSizing } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list-refresh/scope-popup-sizing';
import { ScopeRow } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list-refresh/scope-row';
import { ScopeFileBlobPreviewModal } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list-refresh/ScopeFileBlobPreviewModal';
import { useUpdateTime } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list/useUpdateTime';
import { ConversationListRowStatusChip, ConversationStatusLabel } from '@atlassian/conversation-assistant-ui-components/ui/conversation-status-label';
import { getAgentSessionStateBadgeStatus, getConversationListRowLoadingStatus } from '@atlassian/conversation-assistant-ui-components/utils/conversation-task-status-indicator';
import { isDefaultRovoChat } from '@atlassian/conversation-assistant-utils/default-agent';
import { ChatListItem as SharedChatListItem } from '@atlassian/rovo-platform-ui-components/chat-list/ChatListItem';
import type { ChatListItemContainerProps } from '@atlassian/rovo-platform-ui-components/chat-list/types';
import { SessionStatusIcon } from '@atlassian/rovo-platform-ui-components/session-details/SessionStatusIcon';
import { SessionAgent } from '@atlassian/rovo-platform-ui-components/session-details/SessionAgent';
import { SessionContext } from '@atlassian/rovo-platform-ui-components/session-details/SessionContext';
import { SessionDetailsList } from '@atlassian/rovo-platform-ui-components/session-details/SessionDetailsList';
import { SessionLastUpdated } from '@atlassian/rovo-platform-ui-components/session-details/SessionLastUpdated';
import { SessionStatusInline } from '@atlassian/rovo-platform-ui-components/session-details/SessionStatusInline';
import { useSpaces, useSpacesLoading } from '@atlassian/rovo-spaces/controllers/space-store';
import type { Space } from '@atlassian/rovo-spaces/controllers/space-store/types';
import { createEmojiProvider } from '@atlassian/rovo-spaces/utils/emoji-provider';
import { COLLAPSE_ELEM_BEFORE, TESTID_PREFIX } from '../../../common/constants';
import { usePinnedConversations } from '../../../common/hooks/use-pinned-conversations';
import commonMessages from '../../../common/messages';
import type { Conversation, ConversationListProps } from '../../../common/types';
import { ButtonMenuItem } from '../../../common/ui/button-menu-item';
import { LinkMenuItem } from '../../../common/ui/link-menu-item';
import { List } from '../../../common/ui/list';
import { MenuSection } from '../../../common/ui/menu-section';
import { MenuSectionHeading } from '../../../common/ui/menu-section/menu-section-heading';
import { type ConversationGroup, groupConversationsByTime } from '../../../common/utils/date-utils';
import mergeRefs from '../../../common/utils/merge-refs';
import { AgentParticipants, getAgentFooterIdentities } from './agent-participants';
import messages from './messages';
import { MoveToSpaceSubmenu } from './move-to-space-submenu';
const styles = {
  notificationDot: "_0bjKvDS5Zs _39xV02Jg58 _0jFU0VJg58 _0KLXrukLmD",
  statusContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _3YEZNOdnbC",
  trailingStatusSlot: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _0jFU0VQAma _3YEZNOdnbC",
  leadingIndicator: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _1VJPcaTCo3 _3YEZNOdnbC",
  sessionAgentInfo: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _4ouGXIdnbC _1EqgXlN91d _3YEZNOdnbC",
  pinnedIndicator: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _1UtDYzZpcK _3YEZNOdnbC",
  pinnedIndicatorIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _1VJPcagSbW _0yKXXaDIqT",
  scopeOverflowCount: "_3YEZNOdnbC _1ANEUSLRg7 _0GTcwRLl21",
  firstScopeTooltipTrigger: "_1mT5xdRAKS _42Yu6B7dHp _3iDTPbccYA _0hPCNLDIqT _1EqgXlN91d _4ouGXIdnbC",
  firstScopeTooltipClickableTrigger: "_0wOv4Q7zJH",
  scopeTooltipContent: "_0bjKvDKxmn _2sNsIg7NXe _4c065U1Y8M _2Y7lL4gVvo _24h04i2Njc _39xV02W9qI _0KLXrugozt _1UtDYze5R3 _4bt5LAnQyn _3zvHkHwPeg _1T2N03wPeg",
  scopeNameWrapper: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
  scopeNameClickableWrapper: "_0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
  elemAfterStyles: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuDIqT _0jFU0VbKFA _4xdlr07p2s"
};
export type ChatListItemProps = Omit<ConversationListProps, 'conversations' | 'currentConversation' | 'onConversationPinToggle' | 'onViewAllConversations'> & {
  testIdDisambiguator: string;
  conversation: Conversation;
  isSelected: boolean;
  isADSNavigationEnabled: boolean;
  isNewAllConversationScreenEnabled: boolean;
  isSpinnerOverlayConversationIconEnabled: boolean;
  spaces: Space[];
  isLoadingSpaces: boolean;
  spaceEmojiProvider: Promise<EmojiProvider>;
  cloudId?: string;
  level?: number;
  onConversationPinToggle?: (conversation: Conversation, isPinned: boolean) => boolean;
  isPinnedChatsEnabled?: boolean;
  pinLimitError?: {
    maxPinnedConversations?: number;
  };
  onDismissPinLimitError?: () => void;
  listItemRef?: React.Ref<HTMLDivElement>;
};
export const ChatListItem = ({
  testIdDisambiguator,
  conversation,
  onSelectConversation,
  onConversationRename,
  onConversationDelete,
  onConversationMoveToSpace,
  onConversationMoveToNewSpace,
  isSelected,
  level = 1,
  isADSNavigationEnabled,
  isNewAllConversationScreenEnabled,
  isSpinnerOverlayConversationIconEnabled,
  spaces,
  isLoadingSpaces,
  spaceEmojiProvider,
  cloudId,
  onConversationPinToggle,
  isPinnedChatsEnabled = false,
  pinLimitError,
  onDismissPinLimitError,
  listItemRef
}: ChatListItemProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const {
    showFlag
  } = useFlags();
  const {
    sendAnalyticsEvent
  } = useAnalytics();
  const isAgentSessionStateBadgeEnabled = fg('rovo-chat-ai-inbox');
  const {
    setStagingAreaMode
  } = useStagingAreaActions();
  const [fileScopePreview, setFileScopePreview] = useState<{
    link: string;
    name: string;
  } | null>(null);
  const [isScopeTooltipOpen, setIsScopeTooltipOpen] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const relativeTime = useUpdateTime({
    isoDate: conversation.lastMessageTimestamp,
    relativeTimeStyle: 'long',
    compact: isAgentSessionStateBadgeEnabled
  });
  const parsedLastMessageTimestamp = conversation.lastMessageTimestamp ? Date.parse(conversation.lastMessageTimestamp) : Number.NaN;
  const lastStateChangeAt = Number.isFinite(parsedLastMessageTimestamp) ? parsedLastMessageTimestamp : undefined;
  const mentionAgentsExperimentEnabled = isExperimentEnabled('rovo_chat_mention_agents');
  const agentFooterIdentities = useMemo(() => {
    if (!mentionAgentsExperimentEnabled) {
      return [];
    }
    return getAgentFooterIdentities({
      participants: conversation.participants,
      conversationAgent: conversation.agent
    });
  }, [conversation.agent, conversation.participants, mentionAgentsExperimentEnabled]);
  const shouldUseParticipantAgentInfo = agentFooterIdentities.length > 0;
  const isDefaultRovoAgent = Boolean(conversation.agent?.is_default || isDefaultRovoChat({
    agentId: conversation.agent?.agent_id,
    agentNamedId: conversation.agent?.agent_named_id
  }));
  const isDefaultAgent = isAgentSessionStateBadgeEnabled && isDefaultRovoAgent;
  const agentName = isDefaultAgent ? formatMessage(messages.rovoAgentName) : conversation.agent?.agent_name;
  const shouldShowAgentInfo = isAgentSessionStateBadgeEnabled ? !shouldUseParticipantAgentInfo : mentionAgentsExperimentEnabled ? !shouldUseParticipantAgentInfo && !isDefaultRovoAgent : !conversation.agent?.is_default && !isDefaultRovoAgent;
  const scopes = conversation.scopes;
  const firstScope = scopes?.[0];
  const scopesOverflowCount = scopes && scopes.length > 1 ? scopes.length - 1 : 0;
  const {
    maxWidth: scopePopupMaxWidth,
    placement: scopePopupPlacement,
    setTrigger: setScopePopupTrigger,
    updateSizing: updateScopePopupSizing
  } = useScopePopupSizing(isScopeTooltipOpen);
  const shouldShowUnreadStatus = conversation.readStatus === false;
  const conversationListRowStatus = getConversationListRowLoadingStatus(conversation, shouldShowUnreadStatus);
  const showTaskStatusFooterRow = conversationListRowStatus !== undefined;
  const shouldUseSessionDetailsLayout = isNewAllConversationScreenEnabled && isAgentSessionStateBadgeEnabled;
  const badgeStatus = isAgentSessionStateBadgeEnabled ? getAgentSessionStateBadgeStatus(conversation.agentSessionState) : undefined;
  const shouldRenderRelativeTimeInFooter = !isAgentSessionStateBadgeEnabled && Boolean(relativeTime);
  const shouldShowAgentSessionStateBadge = isNewAllConversationScreenEnabled && badgeStatus !== undefined && conversationListRowStatus !== 'loading';
  const shouldShowLeadingUnreadDot = isNewAllConversationScreenEnabled && isAgentSessionStateBadgeEnabled && shouldShowUnreadStatus && badgeStatus === undefined && conversationListRowStatus === undefined;
  const shouldShowLeadingLoadingIndicator = isNewAllConversationScreenEnabled && isAgentSessionStateBadgeEnabled && conversationListRowStatus === 'loading';
  const testId = `${TESTID_PREFIX}-history-item-${testIdDisambiguator}`;

  // ── Computed visual slots ─────────────────────────────────────────────

  const footerTextColor = 'color.text.subtlest';
  const handleScopeLinkClicked = useCallback((variant: 'default' | 'tooltip') => {
    sendAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'scopeLink',
      attributes: {
        isTooltip: variant === 'tooltip'
      }
    });
  }, [sendAnalyticsEvent]);
  const handleScopeLinkHovered = useCallback(() => {
    sendAnalyticsEvent({
      action: 'hovered',
      actionSubject: 'link',
      actionSubjectId: 'scopeLink',
      attributes: {
        scopeCount: scopes?.length ?? 0
      }
    });
  }, [sendAnalyticsEvent, scopes]);
  const handleScopeTooltipClose = useCallback(() => {
    setIsScopeTooltipOpen(false);
  }, []);
  const handleScopeTooltipTriggerClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    updateScopePopupSizing(event.currentTarget);
    setIsScopeTooltipOpen(isOpen => !isOpen);
  }, [updateScopePopupSizing]);
  const handleScopeTooltipTriggerKeyDown = useCallback((event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      updateScopePopupSizing(event.currentTarget);
      setIsScopeTooltipOpen(isOpen => !isOpen);
    }
  }, [updateScopePopupSizing]);
  const scopeDetails = !showTaskStatusFooterRow && firstScope ? <Popup isOpen={isScopeTooltipOpen} onClose={handleScopeTooltipClose} placement={scopePopupPlacement} shouldRenderToParent shouldUseCaptureOnOutsideClick content={() => <TooltipPrimitive placement="bottom" role="tooltip" style={{
    maxWidth: `${scopePopupMaxWidth}px`
  }}>
						<Box testId="rovo-navigation-scope-popup-content" style={{
      maxWidth: `${scopePopupMaxWidth}px`
    }} xcss={styles.scopeTooltipContent}>
							<Stack space="space.100">
								{(scopes ?? []).map((scope, index) => <Box key={`${scope.link ?? 'scope'}-${index}`}>
										<ScopeRow scope={scope} variant="tooltip" maxLines={1} onFilePreview={(link, name) => setFileScopePreview({
            link,
            name
          })} onScopeLinkClick={handleScopeLinkClicked} />
									</Box>)}
							</Stack>
						</Box>
					</TooltipPrimitive>} trigger={triggerProps => <Box as="span" role="button" tabIndex={0} xcss={cx(styles.firstScopeTooltipTrigger, styles.firstScopeTooltipClickableTrigger)} {...triggerProps} ref={mergeRefs([triggerProps.ref, element => setScopePopupTrigger(element)])} onClick={handleScopeTooltipTriggerClick} onKeyDown={handleScopeTooltipTriggerKeyDown}>
						<Inline alignBlock="center" space="space.050">
							<Box xcss={cx(styles.scopeNameWrapper, styles.scopeNameClickableWrapper)}>
								<ScopeRow scope={{
          ...firstScope,
          link: undefined
        }} variant="default" maxLines={1} showIconWithoutLink onScopeLinkHover={handleScopeLinkHovered} />
							</Box>
							{scopesOverflowCount > 0 && <Box as="span" xcss={styles.scopeOverflowCount}>
									<Text as="span" size="small" weight="regular" align="start" color={footerTextColor}>
										{formatMessage(messages.scopesOverflowCount, {
            count: scopesOverflowCount
          })}
									</Text>
								</Box>}
						</Inline>
					</Box>} /> : null;
  const legacyDescription = isNewAllConversationScreenEnabled ? <Inline alignBlock="center" space="space.050">
			{showTaskStatusFooterRow && <ConversationStatusLabel conversation={conversation} showStatusIcon={false} />}
			{!showTaskStatusFooterRow && shouldUseParticipantAgentInfo && <AgentParticipants identities={agentFooterIdentities} cloudId={cloudId} textColor={footerTextColor} />}
			{!showTaskStatusFooterRow && shouldShowAgentInfo && conversation.agent && <React.Fragment>
					<AgentAvatar agentNamedId={conversation.agent.agent_named_id} agentId={conversation.agent.agent_id} agentIdentityAccountId={conversation.agent.identity_account_id} size="xxsmall" showBorder={false} isForgeAgent={fg('rovo_agent_support_a2a_avatar') ? isForgeAgentByCreatorType((conversation.agent.creator_type as AgentCreatorType)) : conversation.agent.creator_type === 'THIRD_PARTY' || conversation.agent.creator_type === 'FORGE'} forgeAgentIconUrl={conversation.agent.forge_url} />
					<Text size="small" weight="regular" maxLines={1} align="start" color={footerTextColor}>
						{agentName}
					</Text>
				</React.Fragment>}
			{!showTaskStatusFooterRow && firstScope && <React.Fragment>
					{(shouldUseParticipantAgentInfo || shouldShowAgentInfo && conversation.agent) && <Text size="small" color={footerTextColor}>
							{formatMessage(messages.footerSeparator)}
						</Text>}
					{scopeDetails}
				</React.Fragment>}
			{shouldRenderRelativeTimeInFooter && <React.Fragment>
					{(shouldUseParticipantAgentInfo || shouldShowAgentInfo && conversation.agent || firstScope || showTaskStatusFooterRow) && <Text size="small" color={footerTextColor}>
							{formatMessage(messages.footerSeparator)}
						</Text>}
					<Text size="small" weight="regular" maxLines={1} align="start" color={footerTextColor}>
						{relativeTime}
					</Text>
				</React.Fragment>}
		</Inline> : undefined;
  const sessionStatus = conversationListRowStatus === 'loading' ? 'thinking' : badgeStatus;
  const sessionAgent = conversation.agent ? [{
    id: conversation.agent.agent_id ?? conversation.agent.agent_named_id ?? 'agent',
    name: agentName ?? '',
    agentId: conversation.agent.agent_id,
    agentIdentityAccountId: conversation.agent.identity_account_id,
    agentNamedId: conversation.agent.agent_named_id
  }] : [];
  const sessionDetailsDescription = isNewAllConversationScreenEnabled ? <SessionDetailsList testId={`${testId}-session-details`}>
			{shouldUseParticipantAgentInfo && cloudId ? <Box as="span" xcss={styles.sessionAgentInfo}>
					<AgentParticipants identities={agentFooterIdentities} cloudId={cloudId} textColor={footerTextColor} showName={!sessionStatus} />
				</Box> : null}
			{shouldShowAgentInfo && conversation.agent ? <SessionAgent agents={sessionAgent} showNames={!sessionStatus} isDefaultAgent={isDefaultAgent} iconSize={16} /> : null}
			{sessionStatus ? <SessionStatusInline status={sessionStatus} showIcon={false} isDefaultAgent textSize="small" testId={`${testId}-status`} /> : showTaskStatusFooterRow ? <SessionContext context={<ConversationStatusLabel conversation={conversation} />} /> : null}
			{scopeDetails ? <SessionContext context={scopeDetails} /> : null}
			{lastStateChangeAt != null ? <SessionLastUpdated lastStateChangeAt={lastStateChangeAt} testId={`${testId}-last-updated`} /> : null}
		</SessionDetailsList> : undefined;
  const description = isNewAllConversationScreenEnabled ? isAgentSessionStateBadgeEnabled ? sessionDetailsDescription : legacyDescription : undefined;
  const onPinToggleClicked = useCallback((event?: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    event?.stopPropagation();
    onConversationPinToggle?.(conversation, !conversation.isPinned);
    setIsMoreMenuOpen(false);
  }, [conversation, onConversationPinToggle]);
  const pinLimitDescription = pinLimitError?.maxPinnedConversations !== undefined ? formatMessage(messages.pinLimitPopupDescriptionWithLimit, {
    limit: pinLimitError.maxPinnedConversations
  }) : formatMessage(messages.pinLimitPopupDescription);
  useEffect(() => {
    if (!pinLimitError) {
      return;
    }
    showFlag({
      id: 'rovo-navigation.pin-limit',
      title: formatMessage(messages.pinLimitPopupTitle),
      description: pinLimitDescription,
      icon: <InformationIcon label="" color={"var(--ds-icon-information, #357DE8)"} />,
      isAutoDismiss: true,
      autoDismissSeconds: 5
    });
    onDismissPinLimitError?.();
  }, [formatMessage, onDismissPinLimitError, pinLimitDescription, pinLimitError, showFlag]);
  const pinnedIndicator = isPinnedChatsEnabled && conversation.isPinned ? <Box xcss={styles.pinnedIndicator} testId={`${TESTID_PREFIX}-history-item-pinned-indicator-${testIdDisambiguator}`}>
				<Box xcss={styles.pinnedIndicatorIcon}>
					<PinFilledIcon label="" color="currentColor" size="small" />
				</Box>
			</Box> : null;
  const shouldShowTrailingStatusSlot = isNewAllConversationScreenEnabled && !isAgentSessionStateBadgeEnabled && (conversationListRowStatus !== undefined || shouldShowUnreadStatus);
  const shouldReserveTrailingStatusSlot = isNewAllConversationScreenEnabled && (shouldShowTrailingStatusSlot || isPinnedChatsEnabled && conversation.isPinned);
  const elemAfter = <Box xcss={styles.elemAfterStyles}>
			{shouldReserveTrailingStatusSlot ? <Box xcss={styles.statusContainer} testId={`${TESTID_PREFIX}-history-item-status-slot-${testIdDisambiguator}`}>
					<ConversationListRowStatusChip conversation={conversation} showUnreadDot={!isAgentSessionStateBadgeEnabled} testId={shouldShowUnreadStatus ? `${TESTID_PREFIX}-history-item-unread-indicator-${testIdDisambiguator}` : undefined} />
				</Box> : null}
			{pinnedIndicator}
		</Box>;
  const size = 'small';

  // ── Callbacks ─────────────────────────────────────────────────────────

  const onSelect = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    onSelectConversation(conversation, isADSNavigationEnabled);
    setStagingAreaMode(undefined, undefined);
  }, [onSelectConversation, conversation, isADSNavigationEnabled, setStagingAreaMode]);
  const onRename = useMemo(() => {
    if (!onConversationRename) {
      return undefined;
    }
    return async (newName: string) => {
      const result = await onConversationRename(conversation, newName);
      if (result?.hasError) {
        return {
          error: 'Rename failed'
        };
      }
      return undefined;
    };
  }, [onConversationRename, conversation]);
  const onDelete = useMemo(() => {
    if (!onConversationDelete) {
      return undefined;
    }
    return () => {
      onConversationDelete(conversation);
    };
  }, [onConversationDelete, conversation]);

  // ── More-menu items (product-specific) ────────────────────────────────

  const pinMenuItem = onConversationPinToggle ? <ButtonItem testId={`${TESTID_PREFIX}-history-item-pin-menu-${testIdDisambiguator}`} iconBefore={conversation.isPinned ? <PinFilledIcon label="" /> : <PinIcon label="" />} onClick={() => onPinToggleClicked()}>
			{formatMessage(conversation.isPinned ? messages.moreMenuUnpinLabel : messages.moreMenuPinLabel)}
		</ButtonItem> : undefined;
  const moveToSpaceMenuItem = (onConversationMoveToSpace || onConversationMoveToNewSpace) && FeatureGates.getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? <MoveToSpaceSubmenu testIdDisambiguator={testIdDisambiguator} conversation={conversation} spaces={spaces} isLoadingSpaces={isLoadingSpaces} spaceEmojiProvider={spaceEmojiProvider} onConversationMoveToSpace={onConversationMoveToSpace} onConversationMoveToNewSpace={onConversationMoveToNewSpace} onClose={() => {}} /> : undefined;
  const moreMenuItems = pinMenuItem || moveToSpaceMenuItem ? <>
				{pinMenuItem}
				{moveToSpaceMenuItem}
			</> : undefined;
  // ── After content (modals) ────────────────────────────────────────────

  const afterContent = fileScopePreview ? <ScopeFileBlobPreviewModal isOpen onClose={() => setFileScopePreview(null)} fileUrl={fileScopePreview.link} fileName={fileScopePreview.name} formatMessage={formatMessage} filePreviewFallbackDescription={messages.filePreviewFallbackDescription} cloudId={cloudId} /> : null;

  // ── renderContainer ───────────────────────────────────────────────────

  const renderContainer = useCallback((props: ChatListItemContainerProps) => <LinkMenuItem isADSNavigationEnabled={isADSNavigationEnabled} isContentTooltipDisabled href="#" testId={props.testId} level={level} onClick={props.onClick} listItemRef={listItemRef} actionsOnHover={props.actionsOnHover} isSelected={props.isSelected} titleSuffix={props.titleSuffix} isNewAllConversationScreenEnabled={isNewAllConversationScreenEnabled} size={props.size} elemBeforeAlign={shouldUseSessionDetailsLayout ? 'start' : undefined} elemBefore={props.elemBefore ?? (shouldUseSessionDetailsLayout ? <Box xcss={styles.leadingIndicator} aria-hidden="true" /> : COLLAPSE_ELEM_BEFORE)} noActiveBackground description={isNewAllConversationScreenEnabled ? props.description : undefined} elemAfter={props.elemAfter}>
				{props.children}
			</LinkMenuItem>, [isADSNavigationEnabled, isNewAllConversationScreenEnabled, level, listItemRef, shouldUseSessionDetailsLayout]);
  return <SharedChatListItem id={conversation.id} name={conversation.name} elemBefore={shouldShowLeadingLoadingIndicator ? <Box xcss={styles.leadingIndicator}>
						<ConversationListRowStatusChip conversation={conversation} showUnreadDot={false} testId={`${testId}-loading-indicator`} />
					</Box> : shouldShowAgentSessionStateBadge ? <Box xcss={styles.leadingIndicator}>
						<SessionStatusIcon status={badgeStatus} color={"var(--ds-icon-accent-blue, #357DE8)"} testId={`${testId}-needs-input-icon`} />
					</Box> : shouldShowLeadingUnreadDot ? <Box xcss={styles.leadingIndicator}>
						<ConversationListRowStatusChip conversation={conversation} showUnreadDot unreadDotSize="gated" testId={`${testId}-unread-indicator`} />
					</Box> : undefined} titleSuffix={undefined} description={description} elemAfter={elemAfter} isSelected={isSelected} size={size} onSelect={onSelect} onRename={onRename} onDelete={onDelete} moreMenuItems={moreMenuItems} isMoreMenuOpen={isMoreMenuOpen} onMoreMenuOpenChange={setIsMoreMenuOpen} renderContainer={renderContainer} afterContent={afterContent} testId={testId} renameLabel={formatMessage(messages.moreMenuRenameLabel)} deleteLabel={formatMessage(messages.moreMenuDeleteLabel)} moreButtonLabel={formatMessage(commonMessages.moreBtnLabel)} renameInputLabel={formatMessage(messages.renameInputLabel)} confirmRenameLabel={formatMessage(messages.confirmRenameLabel)} cancelRenameLabel={formatMessage(messages.cancelRenameLabel)} />;
};
const listStyles = {
  noPaddingInlineStart: "_0LQT5EPgdg"
};
export type ChatListMenuItemsProps = ConversationListProps & {
  level?: number;
  isADSNavigationEnabled: boolean;
  isNewAllConversationScreenEnabled?: boolean;
  isSpinnerOverlayConversationIconEnabled?: boolean;
  cloudId?: string;
};
const prefersReducedMotionQuery = '(prefers-reduced-motion: reduce)';
const pinReorderAnimatingAttribute = 'data-pin-reorder-animating';
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
const pinReorderAnimationTransition = `transform ${"var(--ds-duration-medium, 200ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`;
const shouldReduceMotion = () => typeof window !== 'undefined' && window.matchMedia?.(prefersReducedMotionQuery).matches === true;
export const ChatListMenuItems = ({
  conversations = [],
  currentConversation,
  onViewAllConversations,
  onConversationPinToggle,
  isADSNavigationEnabled,
  isNewAllConversationScreenEnabled = false,
  isSpinnerOverlayConversationIconEnabled = false,
  cloudId = '',
  ...props
}: ChatListMenuItemsProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const isPinnedChatsEnabled = fg('rovo_chat_pinned_fe');
  const conversationRowRefs = useRef<Map<string, HTMLDivElement>>(new Map());
  const previousRowRectsForPinReorder = useRef<Map<string, DOMRect> | null>(null);
  const shouldAnimateNextPinReorder = useRef(false);
  const activePinReorderAnimationCleanups = useRef<(() => void)[]>([]);
  const clearPinReorderAnimations = useCallback(() => {
    for (const cleanup of activePinReorderAnimationCleanups.current) {
      cleanup();
    }
    activePinReorderAnimationCleanups.current = [];
  }, []);
  const captureConversationRowRects = useCallback(() => {
    const rowRects = new Map<string, DOMRect>();
    for (const [conversationId, element] of conversationRowRefs.current) {
      rowRects.set(conversationId, element.getBoundingClientRect());
    }
    return rowRects;
  }, []);
  const captureRowsForPinReorder = useCallback(() => {
    previousRowRectsForPinReorder.current = captureConversationRowRects();
    shouldAnimateNextPinReorder.current = true;
  }, [captureConversationRowRects]);
  const {
    applyOptimisticPinnedState,
    compareConversationsByPinnedState,
    handleConversationPinToggle,
    pinLimitError,
    dismissPinLimitError
  } = usePinnedConversations({
    conversations,
    isPinnedChatsEnabled,
    onConversationPinToggle,
    onBeforeOptimisticStateChange: captureRowsForPinReorder
  });
  const filteredConversations = React.useMemo(() => {
    const visibleConversations = conversations.filter(convo => !convo.isEmpty);
    if (!isPinnedChatsEnabled) {
      return visibleConversations;
    }
    return visibleConversations.map(conversation => {
      return applyOptimisticPinnedState(conversation);
    });
  }, [applyOptimisticPinnedState, conversations, isPinnedChatsEnabled]);
  const conversationsOrderedByPinnedState = React.useMemo(() => isPinnedChatsEnabled ? [...filteredConversations].sort(compareConversationsByPinnedState) : filteredConversations, [compareConversationsByPinnedState, filteredConversations, isPinnedChatsEnabled]);
  useIsomorphicLayoutEffect(() => {
    if (!shouldAnimateNextPinReorder.current) {
      return;
    }
    shouldAnimateNextPinReorder.current = false;
    const previousRowRects = previousRowRectsForPinReorder.current;
    previousRowRectsForPinReorder.current = null;
    if (!previousRowRects) {
      clearPinReorderAnimations();
      return;
    }
    clearPinReorderAnimations();
    if (shouldReduceMotion()) {
      return;
    }
    const movedRows: HTMLDivElement[] = [];
    for (const [conversationId, element] of conversationRowRefs.current) {
      const previousRect = previousRowRects.get(conversationId);
      if (!previousRect) {
        continue;
      }
      const currentRect = element.getBoundingClientRect();
      const deltaY = previousRect.top - currentRect.top;
      if (deltaY === 0) {
        continue;
      }
      element.style.transform = `translateY(${deltaY}px)`;
      element.style.transition = 'none';
      element.setAttribute(pinReorderAnimatingAttribute, 'true');
      movedRows.push(element);
    }
    const startAnimation = () => {
      activePinReorderAnimationCleanups.current = movedRows.map(element => {
        element.style.transform = '';
        element.style.transition = pinReorderAnimationTransition;
        const cleanup = bind(element, {
          type: 'transitionend',
          listener: () => {
            element.style.transition = '';
            element.removeAttribute(pinReorderAnimatingAttribute);
            cleanup();
          }
        });
        return cleanup;
      });
    };
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(startAnimation);
    } else {
      window.setTimeout(startAnimation, 0);
    }
  }, [clearPinReorderAnimations, conversationsOrderedByPinnedState]);
  useEffect(() => clearPinReorderAnimations, [clearPinReorderAnimations]);
  const groupedConversations = React.useMemo(() => {
    if (!isPinnedChatsEnabled) {
      return groupConversationsByTime(filteredConversations, formatMessage);
    }
    const pinnedConversations = filteredConversations.filter(conversation => conversation.isPinned).sort(compareConversationsByPinnedState);
    const unpinnedConversations = filteredConversations.filter(conversation => !conversation.isPinned);
    const timeGroups = groupConversationsByTime(unpinnedConversations, formatMessage);
    if (pinnedConversations.length === 0) {
      return timeGroups;
    }
    return [{
      label: formatMessage(messages.pinnedConversationsLabel),
      conversations: pinnedConversations
    }, ...timeGroups];
  }, [compareConversationsByPinnedState, filteredConversations, formatMessage, isPinnedChatsEnabled]);
  const onViewAllConversationsClick = useCallback(() => {
    onViewAllConversations();
  }, [onViewAllConversations]);
  const spaces = useSpaces();
  const isLoadingSpaces = useSpacesLoading();
  const spaceEmojiProvider = useMemo(() => createEmojiProvider(cloudId), [cloudId]);
  const renderConversationList = (group: ConversationGroup, groupIndex: number) => {
    const listItems = group.conversations.map((convo, i) => <ChatListItem isADSNavigationEnabled={isADSNavigationEnabled} key={convo.id} testIdDisambiguator={`${groupIndex}-${i}`} conversation={convo} isSelected={convo.id === currentConversation?.id} isNewAllConversationScreenEnabled={isNewAllConversationScreenEnabled} isSpinnerOverlayConversationIconEnabled={isSpinnerOverlayConversationIconEnabled} spaces={spaces} isLoadingSpaces={isLoadingSpaces} spaceEmojiProvider={spaceEmojiProvider} cloudId={cloudId} isPinnedChatsEnabled={isPinnedChatsEnabled} listItemRef={element => {
      if (element) {
        conversationRowRefs.current.set(convo.id, element);
      } else {
        conversationRowRefs.current.delete(convo.id);
      }
    }} {...props} onConversationPinToggle={isPinnedChatsEnabled && onConversationPinToggle ? handleConversationPinToggle : undefined} pinLimitError={pinLimitError?.conversationId === convo.id ? {
      maxPinnedConversations: pinLimitError.maxPinnedConversations
    } : undefined} onDismissPinLimitError={() => {
      dismissPinLimitError(convo.id);
    }} />);
    if (isADSNavigationEnabled) {
      return <AtlasMenuList testId={`${TESTID_PREFIX}-history-items-${groupIndex}`}>
					{listItems}
				</AtlasMenuList>;
    }
    return <List testId={`${TESTID_PREFIX}-history-items-${groupIndex}`} xcss={listStyles.noPaddingInlineStart}>
				{listItems}
			</List>;
  };
  const grouped = groupedConversations.map((group, groupIndex) => {
    const conversationList = renderConversationList(group, groupIndex);
    const MenuSectionComponent = isADSNavigationEnabled ? AtlasMenuSection : MenuSection;
    return <MenuSectionComponent key={group.label} isMenuListItem>
				{isADSNavigationEnabled ? <AtlasMenuSectionHeading>{group.label}</AtlasMenuSectionHeading> : <MenuSectionHeading label={group.label}>{group.label}</MenuSectionHeading>}
				{conversationList}
			</MenuSectionComponent>;
  });
  return <>
			{isNewAllConversationScreenEnabled ? renderConversationList({
      label: '',
      conversations: conversationsOrderedByPinnedState
    }, 0) : grouped}
			<ButtonMenuItem isADSNavigationEnabled={isADSNavigationEnabled} elemBefore={<ViewAllIcon label="" />} onClick={onViewAllConversationsClick}>
				{formatMessage(messages.viewAllConversationsLabel)}
			</ButtonMenuItem>
		</>;
};